// Analytics events enum
export enum Events {
  SignupStarted = 'signup_started',
  SignupSucceeded = 'signup_succeeded',
  EmailConfirmed = 'email_confirmed',
  EmailVerificationComplete = 'email_verification_complete',
  OnboardingStarted = 'onboarding_started',
  OnboardingStepCompleted = 'onboarding_step_completed',
  OnboardingCompleted = 'onboarding_completed',
  VerifyCtaClicked = 'verify_cta_clicked',
  VerificationStarted = 'verification_started',
  VerificationApproved = 'verification_approved',
  VerificationDeclined = 'verification_declined',
  PremiumViewed = 'premium_viewed',
  PremiumCTA = 'premium_cta',
  PremiumUpsellViewed = 'premium_upsell_viewed',
  UpgradeClicked = 'upgrade_clicked',
  GateBlocked = 'gate_blocked',
  // Token Events
  TokenConsumed = 'token_consumed',
  TokenDeclined = 'token_declined',
  TokenTopUpViewed = 'token_top_up_viewed',
  TokenTopUpCompleted = 'token_top_up_completed',
  // Action Events
  AttemptedJoinBlocked = 'attempted_join_blocked',
  AttemptedCreateBlocked = 'attempted_create_blocked',
  VybeCreated = 'vybe_created',
  VybeApplicationSent = 'vybe_application_sent',
  VybeJoined = 'vybe_joined',
}

// Analytics tracking function
export const track = (event: Events, properties?: Record<string, any>) => {
  console.debug('[analytics]', event, properties);
  
  // In a real app, you would send this to your analytics provider
  // For now, we'll just log to console for debugging
  
  // Example: Send to analytics service
  // analytics.track(event, properties);
};

// Helper to track gate blocks
export const trackGateBlock = (gate: string, reason: string, userId?: string) => {
  track(Events.GateBlocked, {
    gate,
    reason,
    userId,
    timestamp: new Date().toISOString()
  });
};